module.exports = __webpack_public_path__ + "img/FotoMo1.e4ee6a43.png";